import { FormTemplate } from 'data/template/template.types';

// eslint-disable-next-line import/prefer-default-export
export const targetDomainTemplate: FormTemplate = {
  version: '1.0.0',
  name: 'Target Domain',
  key: 'targetDomain',
  main: {
    metadata: {
      layout: {
        rows: [
          ['id'],
          ['domain', 'description', '$empty'],
        ],
      },
    },
    fields: {
      id: {
        type: 'text',
        hide: 'true',
        initial: '',
      },
      domain: {
        label: 'Domain',
        hintMessage: 'Max 16 characters with no spaces.',
        type: 'text',
        initial: '',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 32,
            },
            {
              type: 'regexp',
              regexp: ['letters', 'digits', '-_.~!@#$%^*+?'],
              errorMessage: 'Can include letters, digits and the following special characters: -_.~!@#$%^*+?. Please re-enter.',
            },
          ],
        },
      },
      description: {
        label: 'Description',
        type: 'text',
        initial: '',
        validation: {
          validators: [
            {
              type: 'length',
              length: 256,
            },
          ],
        },
      },
    },
  },
};
